class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (!facetForm) return;

    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    if (this.hasAttribute('data-defer-filter-submit')) {
      this.setupDeferredFacetApply();
    }
  }

  setupDeferredFacetApply() {
    const drawerDetails = this.closest('.mobile-facets__wrapper')?.querySelector('details.mobile-facets__disclosure');
    if (drawerDetails) {
      drawerDetails.addEventListener('toggle', () => {
        if (!drawerDetails.open) {
          document.querySelectorAll('facet-filters-form[data-defer-filter-submit]').forEach((ff) => {
            if (typeof ff.syncFormStateFromURL === 'function') ff.syncFormStateFromURL();
          });
        }
      });
    }
    const applyBtn = this.querySelector('.js-facets-apply');
    const clearBtn = this.querySelector('.js-facets-clear');
    if (applyBtn) applyBtn.addEventListener('click', this.onDeferredApply.bind(this), true);
    if (clearBtn) clearBtn.addEventListener('click', this.onDeferredClear.bind(this), true);
  }

  isDeferredFacetField(target) {
    if (!target || !target.name) return false;
    if (target.tagName === 'SELECT' && target.name === 'sort_by') return true;
    if (target.tagName === 'INPUT' && target.type === 'checkbox' && target.name.startsWith('filter.')) return true;
    if (target.tagName === 'INPUT' && target.type === 'number' && target.closest('price-range')) return true;
    return false;
  }

  syncFormStateFromURL() {
    const form = this.querySelector('form');
    if (!form) return;
    const params = new URLSearchParams(window.location.search);
    form.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach((cb) => {
      const vals = params.getAll(cb.name);
      cb.checked = vals.includes(cb.value);
    });
    form.querySelectorAll('price-range input[type="number"]').forEach((input) => {
      const v = params.get(input.name);
      input.value = v == null ? '' : v;
    });
    form.querySelectorAll('select[name="sort_by"]').forEach((sortSelect) => {
      if (params.has('sort_by')) {
        sortSelect.value = params.get('sort_by');
      } else {
        sortSelect.selectedIndex = 0;
      }
    });
  }

  onDeferredApply(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const merged = FacetFiltersForm.mergeFacetFormSearchParams();
    const drawer = this.closest('.mobile-facets__wrapper')?.querySelector('details.mobile-facets__disclosure');
    const submitFilters = () => this.onSubmitForm(merged, event);

    if (drawer?.open) {
      drawer.querySelector('summary')?.click();
      setTimeout(submitFilters, 400);
    } else {
      submitFilters();
    }
  }

  onDeferredClear(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    FacetFiltersForm.resetAllFacetForms();
    this.onSubmitForm('', event);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) {
      console.warn('facets.js: #ProductGridContainer not found — add it around the collection product area in your section (see main-collection-product-grid).');
      return;
    }
    const collectionEl = productGridContainer.querySelector('.collection');
    if (collectionEl) collectionEl.classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    const parsed = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (!container || !parsed) {
      console.warn('facets.js: could not update product grid — #ProductGridContainer missing in DOM or section response.');
      return;
    }
    container.innerHTML = parsed.innerHTML;
    const collectionEl = container.querySelector('.collection');
    if (collectionEl) collectionEl.classList.remove('loading');
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  static resetAllFacetForms() {
    document.querySelectorAll('facet-filters-form form').forEach((form) => {
      if (!['FacetSortForm', 'FacetFiltersForm', 'FacetSortDrawerForm'].includes(form.id)) return;
      form.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach((cb) => {
        if (!cb.disabled) cb.checked = false;
      });
      form.querySelectorAll('price-range input[type="number"]').forEach((input) => {
        input.value = '';
      });
      form.querySelectorAll('select[name="sort_by"]').forEach((select) => {
        select.selectedIndex = 0;
      });
    });
  }

  static appendSearchParam(params, key, value) {
    if (value === '' || value == null) return;
    if (key === 'sort_by') {
      params.set(key, value);
      return;
    }
    if (key.startsWith('filter.')) {
      params.append(key, value);
      return;
    }
    params.set(key, value);
  }

  static getPrimaryFiltersForm() {
    const forms = document.querySelectorAll('form#FacetFiltersForm');
    for (const form of forms) {
      if (form.getClientRects().length > 0) return form;
    }
    return forms[0] || null;
  }

  static getActiveSortValue() {
    const selects = document.querySelectorAll('select[name="sort_by"]');
    for (const select of selects) {
      const sortContainer = select.closest('.facet-filters, .mobile-facets__sort');
      if (sortContainer && sortContainer.getClientRects().length === 0) continue;
      if (select.getClientRects().length === 0) continue;
      return select.value;
    }
    return null;
  }

  static mergeFacetFormSearchParams() {
    const host = document.querySelector('facet-filters-form');
    if (!host || typeof host.createSearchParams !== 'function') return '';

    document.querySelectorAll('.no-js-list').forEach((el) => el.remove());

    const merged = new URLSearchParams();
    const primaryForm = FacetFiltersForm.getPrimaryFiltersForm();

    if (primaryForm) {
      const formParams = new URLSearchParams(host.createSearchParams(primaryForm));
      formParams.forEach((value, key) => {
        if (key !== 'sort_by') FacetFiltersForm.appendSearchParam(merged, key, value);
      });
    }

    const sortForm = document.querySelector('form#FacetSortForm, form#FacetSortDrawerForm');
    if (sortForm && sortForm.getClientRects().length > 0) {
      const sortParams = new URLSearchParams(host.createSearchParams(sortForm));
      if (sortParams.has('sort_by')) merged.set('sort_by', sortParams.get('sort_by'));
    } else {
      const sortValue = FacetFiltersForm.getActiveSortValue();
      if (sortValue) merged.set('sort_by', sortValue);
    }

    return merged.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (this.hasAttribute('data-defer-filter-submit') && this.isDeferredFacetField(event.target)) {
      return;
    }
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      this.onSubmitForm(FacetFiltersForm.mergeFacetFormSearchParams(), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
